
import Vue from 'vue'
import marked from 'marked'
import { mapState } from 'vuex'
import { ProjectState } from '../channel.types'

import VRuntimeTemplate from 'v-runtime-template'
import Hotspot from './article_engagement/Hotspot.vue'

import $ from 'domtastic'

const renderer = new marked.Renderer()

//Use this to test the emojis hotspot: http://localhost.player.lumiere.is:8080/c/network-comparison/1/article/1
renderer.link = (href, title, text) =>
  `<a href="${href}" target="_blank">${text}</a>`

export default Vue.extend({
  props: ['text', 'forHero'],

  components: {
    Hotspot,
    VRuntimeTemplate,
  },

  mounted() {
    $('a').on('click', evt => {
      evt.stopPropagation()
    })
  },

  computed: {
    articleTemplate() {
      //This component is typically v-ifed, and the loading variable is joined to the text that loads from the server.
      //In theory the text should be available and defined whenever the v-if allows this component to render.
      //in practice the text is null ~ %1 of the time when the loading passes, causing an error here.
      let isTextReady = this.text && typeof this.text == 'string'
      let compiledText = isTextReady
        ? '<div>' + marked(this.text, { renderer }) + '</div>'
        : '<div></div>'
      return compiledText
    },
    heroActivitySynopsis() {
      let isTextReady = this.text && typeof this.text == 'string'
      let compiledText = isTextReady
        ? '<div>' + marked(this.text, { renderer }) + '</div>'
        : '<div></div>'
      return compiledText
    },
  },
})
